import { createAction } from '@reduxjs/toolkit';
import eventProvider from '../../event/eventProvider';
/* eslint-disable no-unused-vars */
enum ActionType {
  LOGIN_SMS = 'LOGIN_SMS',
  LOGIN_START = 'LOGIN_START',
  LOGIN = 'LOGIN',
  RELOGIN = 'RELOGIN',
  LOGIN_TIMEOUT = 'LOGIN_TIMEOUT',
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
  LOGOUT = 'LOGOUT',
  USER_INFO = 'USER_INFO',
  MISC = 'MISC',
  CLEAN_REUSE_TOKEN = 'CLEAN_REUSE_TOKEN',
  TOKEN_LOGIN = 'TOKEN_LOGIN',
  UPDATE_LOGIN_ERROR_MESSAGE = 'UPDATE_LOGIN_ERROR_MESSAGE',
  ACTION_CHECK_QR_CODE = 'ACTION_CHECK_QR_CODE',
  ACTION_CHANGE_LOGIN_WAY = 'ACTION_CHANGE_LOGIN_WAY',
  SET_OAUTH_TOKEN = 'SET_OAUTH_TOKEN',
  RELOAD = 'RELOAD',
  GET_PASSPORT_TOKEN = 'GET_PASSPORT_TOKEN',
  GET_MQTT_TOKEN = 'GET_MQTT_TOKEN',
}

export const actionLoginOauth = createAction(ActionType.LOGIN_SMS);
export const actionLoginStart = createAction(ActionType.LOGIN_START);
export const actionLogin = createAction(
  eventProvider.makeResponseType(ActionType.LOGIN),
);
export const actionTokenLogin = createAction(
  eventProvider.makeResponseType(ActionType.TOKEN_LOGIN),
);
export const actionLoginTimeOut = createAction(ActionType.LOGIN_TIMEOUT);
export const actionLogOut = createAction(ActionType.LOGOUT);
export const actionFetchMisc = createAction(
  eventProvider.makeResponseType(ActionType.MISC),
);
export const updateLoginErrorMessage = createAction<any>(
  ActionType.UPDATE_LOGIN_ERROR_MESSAGE,
);
export const actionCheckQrCode = createAction<any>(
  ActionType.ACTION_CHECK_QR_CODE,
);
export const actionChangeLoginWay = createAction<any>(
  ActionType.ACTION_CHANGE_LOGIN_WAY,
);
export const actionSetToken = createAction<any>(ActionType.SET_OAUTH_TOKEN);
export const actionReloadCookie = createAction(ActionType.RELOAD);

export default ActionType;
